export default __webpack_public_path__ + "static/media/loader.3af234f2.svg";